
export default (Alpine) => {
	Alpine.store('locations', {
		init() {
		}
	});
};